import { render } from "./ButtonDark.vue?vue&type=template&id=4acd8b2a"
import script from "./ButtonDark.vue?vue&type=script&lang=js"
export * from "./ButtonDark.vue?vue&type=script&lang=js"
script.render = render

export default script